import React from "react";
import useGlobalHook from "use-global-hook";
import * as actions from "../Actions/InvoiceActions";


const initialState = {
    status: 200,
    isLoading: false,
    isLoadingHistory: false,
    message: "",
    header: {},
    invoices: [],
    invoiceSummary: {},
    saldo: {},
    historys: [],
    lastPage: false,
    refresh: false
};

const InvoiceStore = useGlobalHook(React, initialState, actions);

export default InvoiceStore;
